import { render } from "./HomeworkCreateView.vue?vue&type=template&id=080ce249"
import script from "./HomeworkCreateView.vue?vue&type=script&lang=js"
export * from "./HomeworkCreateView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__